import { render } from "./HoroView.vue?vue&type=template&id=7402442c"
import script from "./HoroView.vue?vue&type=script&lang=js"
export * from "./HoroView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__